import store from '../store'
import constants from '../constants'
import { Permission } from '@/webApi/DataModels'
import { findIndex } from 'lodash'

export default {
  install (Vue) {
    Vue.prototype.userHasPermission = function (permissionType:string, permissionValue:string):boolean {
      var userPermissions:Permission[] = store.getters['user/getPermissions']
      return (findIndex(userPermissions, { Type: permissionType, Value: permissionValue }) > -1)
    }

    Vue.prototype.userHasActionBarPermissions = function () {
      return this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SCAN) ||
            this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.DELETE) ||
            this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE) ||
            this.userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.CREATE) ||
            this.userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)
    }
    Vue.prototype.userHasSubmenuPermission = function () {
      return this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK) ||
      this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_WITH_FILE) ||
      this.userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SCAN_WITH_FILE)
    }
  }
}
